import {
  CART_REQUEST,
  CART_SUCCESS,
  CART_FAILURE,
  CART_GET_LIST,
  CART_ADD_ITEM,
  CART_UPDATE_ITEM,
  CART_REMOVE_ITEM,
  CART_CREATE_PRE_ORDER,
  CART_PRE_ORDER_RESTORE,
  CART_CREATE_ORDER,
  CART_GET_DEFAULT_ADDRESS,
  CART_GET_DISCOUNT_LIST
} from '@/store/types'

import axios from '@/store/axios'

/* 
    This maps object keys from backend to frontend
    [backend]: frontend
*/
//const keyMapper = {}

/*
const mapNewKey = (obj, keysMap) => {
  Object.keys(keysMap).map((newKey) => {
    const re = new RegExp(`"${newKey}":`, 'g')
    obj = JSON.parse(JSON.stringify(obj).replace(re, `"${keysMap[newKey]}":`))
  })
  return obj
}
*/
// Set current selected library as default library
const state = {
  cart: null,
  isLoading: false,
  defaultAddress: null,
  error: null,
  area: [
    { nm: 'a1', cd: 1 },
    { nm: 'a2', cd: 2 },
    { nm: 'a3', cd: 3 },
    { nm: 'a4', cd: 4 }
  ],
  discountItems: null
}

const getters = {
  getCart: (state) => state.cart,
  isCartLoading: (state) => state.isLoading,
  getCartDefaultAddress: (state) => state.defaultAddress,
  getCartErrorMessage: (state) =>
    state.error && state.error.response
      ? state.error.response.data.errorState.message
      : state.error,
  getAreaList: (state) => state.area,
  getDiscountItems: (state) => state.discountItems
}

const actions = {
  [CART_ADD_ITEM]: ({ commit }, { id, item }) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)

      axios
        .post(`/purchase/cart/${id}`, item)
        .then((resp) => {
          commit(CART_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  [CART_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)
      axios
        .get(`/purchase/cart/list`)
        .then((resp) => {
          commit(CART_SUCCESS, {
            cart: resp.data.result.cartList
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  [CART_UPDATE_ITEM]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)

      axios
        .put(`purchase/cart/update`, data)
        .then((resp) => {
          commit(CART_SUCCESS, { cart: resp.data.result.cartList })
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  /*
    Expects removeList = {
      [cartCd]: [cartGoodsSeq]
    }
  */
  [CART_REMOVE_ITEM]: ({ commit }, removeList) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)

      const formattedData = Object.keys(removeList).map((key) => {
        return {
          purchase: {
            cartCd: key,
            deleteCartList: removeList[key]
          }
        }
      })

      Promise.all(
        formattedData.map((item) => {
          return axios.delete(`/purchase/cart/delete`, { data: item })
        })
      )
        .then((resp) => {
          commit(CART_SUCCESS, {
            cart: resp[resp.length - 1].data.result.cartList
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  [CART_CREATE_PRE_ORDER]: ({ commit }, order) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)

      axios
        .post(`/purchase/preorder`, order)
        .then((resp) => {
          commit(CART_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  [CART_PRE_ORDER_RESTORE]: (_, order) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/purchase/restore`, order)
        .then((resp) => {
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  [CART_CREATE_ORDER]: ({ commit }, order) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)

      axios
        .post(`/purchase/order`, order)
        .then((resp) => {
          commit(CART_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  [CART_GET_DEFAULT_ADDRESS]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)

      axios
        .get(`/delivery/address`)
        .then((resp) => {
          commit(CART_SUCCESS, {
            defaultAddress: resp.data.result ? resp.data.result.address : null
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  },
  [CART_GET_DISCOUNT_LIST]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit(CART_REQUEST)
      axios
        .put(`/purchase/cart/discount`, data)
        .then((resp) => {
          commit(CART_SUCCESS, {
            discountItems: resp.data.result
          })
          resolve(resp)
        })
        .catch((err) => {
          //실패(err) 일 경우
          commit(CART_FAILURE, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [CART_REQUEST]: (state) => {
    state.isLoading = true
  },
  [CART_SUCCESS]: (state, { cart, defaultAddress, discountItems }) => {
    if (cart) {
      state.cart = cart
    }
    if (defaultAddress) {
      state.defaultAddress = defaultAddress
    }
    if (discountItems) {
      state.discountItems = discountItems
    }
    if (state.error) {
      state.error = null
    }
    state.isLoading = false
  },
  [CART_FAILURE]: (state, err) => {
    if (err) state.error = err
    state.isLoading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
